import {Box, Typography} from "@mui/material"
import {useEffect, type FC} from "react"
import {TruncatedTooltip, EllipsisTypography} from "../../atoms"
import {useConfigProvider} from "../../../config"
import {appInsights} from "../../../config/appInsights"
import {useMutation} from "@tanstack/react-query"
import {fabricEndpoints} from "../../../services"
import moment from "moment"
import {useSessionStorage} from "usehooks-ts"

type TrainingTileItemProps = {
  id: number
  title: string
  imageUrl: string
  startDate: string
  linkUrl: string
}

const TrainingTileItem: FC<TrainingTileItemProps> = (props) => {
  const {id, title, imageUrl, startDate, linkUrl} = props

  const {sendFabricEvents} = fabricEndpoints()

  const {user} = useConfigProvider()

  const sendFabricEventsMutation = useMutation({
    mutationFn: sendFabricEvents,
    mutationKey: ["sendFabricEvents"],
    throwOnError: false,
  })

  const handleClick = async () => {
    window.open(linkUrl, "_blank")

    appInsights.trackEvent({
      name: "VIEW_TRAINING",
      properties: {
        userId: user?.userId,
        trainingId: id,
        title: title,
      },
    })

    await sendFabricEventsMutation.mutateAsync([
      {
        type: "VIEW_TRAINING",
        targetId: `${id || ""}`,
        targetName: title,
        appUrl: window.location.href,
      },
    ])
  }

  const [language] = useSessionStorage("language", "en")
  useEffect(() => {
    if (language) {
      moment.locale(language)
    }
  }, [language])

  return (
    <Box
      component="article"
      aria-label={title}
      onClick={handleClick}
      sx={{
        padding: "0px",
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-end",
        borderRadius: "4px",
        cursor: "pointer",
        position: "relative",
        margin: "0 auto",
      }}
    >
      <Box
        component="header"
        sx={{
          maxWidth: "70%",
          bottom: "22px",
          position: "absolute",
        }}
      >
        <EllipsisTypography
          text={title}
          lines={2}
          fontSize={12}
          color="#FFFFFF"
          styles={{
            backgroundColor: "#226ca6",
            padding: "0px 4px",
            fontFamily: "Open Sans",
            fontWeight: "normal",
            fontStyle: "normal",
            letterSpacing: 0,
            textAlign: "left",
            cursor: "pointer",
          }}
          sx={{
            ":hover": {
              textDecoration: "underline",
            },
          }}
          tooltipComponent={TruncatedTooltip}
        />
      </Box>
      <Typography
        style={{
          backgroundColor: "#fbfbfb",
          padding: "0px 4px",
          fontSize: "12px",
          fontFamily: "Open Sans",
          fontWeight: "normal",
          fontStyle: "normal",
          letterSpacing: 0,
          textAlign: "right",
          color: "#242d35",
          position: "absolute",
          bottom: "1px",
        }}
      >
        {moment(startDate).format("D MMM, YYYY").replace(".", "")}
      </Typography>
    </Box>
  )
}

TrainingTileItem.displayName = "TrainingTileItem"

export default TrainingTileItem
